import _ from 'lodash';
import {
  GET_GROUP_LIST_SUCCESS,
  UPDATE_SELECTED_TAB,
  UPDATE_GROUP_LIST_STORE,
  GET_GROUP_DEVICE_DATA_SUCCESS,
  TOGGLE_GROUP_LIST_LOADING,
  TOGGLE_GROUP_LIST_REFRESHING,
  TOGGLE_TAB_CHANGE_REFRESHING,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  groups: [],
  marginRight: 5,
  activeKey: null,
  currentFamilies: [],
  isLoading: false,
  groupRefreshing: false,
  tabChangeRefresh: false,
  currentFamiliesObj: {},
};

const groupListReducer = (state = initState, action) => {
  // console.log('groupListReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case GET_GROUP_LIST_SUCCESS: {
      const { groups } = payload;
      return {
        ...state,
        groups,
      };
    }

    case GET_GROUP_DEVICE_DATA_SUCCESS: {
      const { groupItem, groupId } = payload;
      const newSuiteList = [];
      _.forEach(groupItem, (value, key) => {
        newSuiteList.push({
          suiteId: key,
          devices: value,
        });
      });
      return {
        ...state,
        currentFamilies: newSuiteList,
        currentFamiliesObj: {
          ...state.currentFamiliesObj,
          [groupId]: newSuiteList,
        },
      };
    }

    case UPDATE_GROUP_LIST_STORE: {
      const { config } = payload;
      return {
        ...state,
        ...config,
      };
    }

    case UPDATE_SELECTED_TAB: {
      const { activeKey } = payload;
      return {
        ...state,
        activeKey,
        tabChangeRefresh: true,
      };
    }

    case TOGGLE_GROUP_LIST_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading,
      };
    }

    case TOGGLE_GROUP_LIST_REFRESHING: {
      const { groupRefreshing } = payload;
      return {
        ...state,
        groupRefreshing,
      };
    }

    case TOGGLE_TAB_CHANGE_REFRESHING: {
      const { tabChangeRefresh } = payload;
      return {
        ...state,
        tabChangeRefresh,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};

export default groupListReducer;
